export const addBulkOrderFormStepsEnum = {
  orderDetails: 1,
  addressDetails: 2,
};

export const paymentMethodEnum = {
  cash: 'pm4ade2768d19w87a2',
};

export const orderSourceEnum = {
  website: 'Website',
  bulkOrder: 'Bulk Order',
};

export const attachmentTypeEnum = {
  image: 'Image',
};
